import { ChevronDown } from "lucide-react";
import * as React from "react";

import { cn } from "@/app/lib/utils";

// A native <select> styled to match `Input`. The browser draws its own arrow at a
// UA-defined inset that never lines up with the 12px padding the other fields use,
// so `appearance-none` drops it and the chevron below takes its place at `right-3`.
// `pr-9` reserves the room so a long option never runs under the chevron.
//
// forwardRef for the same reason as `Input`: this app is on React 18, where `ref`
// is not an ordinary prop, and react-hook-form's register() needs it to attach.
const NativeSelect = React.forwardRef<HTMLSelectElement, React.ComponentProps<"select">>(
	({ className, children, ...props }, ref) => {
		return (
			<div className="relative w-full">
				<select
					ref={ref}
					className={cn(
						"flex h-9 w-full appearance-none rounded-md border border-input bg-transparent py-1 pr-9 pl-3 text-sm shadow-xs outline-none transition-[color,box-shadow] disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50",
						"focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50",
						"aria-invalid:border-destructive aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40",
						className,
					)}
					data-slot="native-select"
					{...props}
				>
					{children}
				</select>
				<ChevronDown
					aria-hidden="true"
					className="pointer-events-none absolute inset-y-0 right-3 my-auto size-4 shrink-0 text-muted-foreground/80"
				/>
			</div>
		);
	},
);

NativeSelect.displayName = "NativeSelect";

export { NativeSelect };
